import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import * as fromReducer from './../state/reducers'
import * as fromSelectors from './../state/selectors/toast.selectors'
import * as toastActions from './../state/actions/toast.actions'
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Toast } from './model/toast';

@Component({
	selector: 'ats-toasts',
	templateUrl: './toast.component.html',
	styleUrls: ['./toast.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class ToastComponent implements OnInit{
	constructor(private store: Store<fromReducer.State>) { }
	toasts$: Observable<Toast[]>;
	toast$: Observable<Toast>;

	ngOnInit() {
		this.toast$ = this.store.pipe(select(fromSelectors.GetToast));
	}

	hide(toast: Toast) {
		this.store.dispatch(toastActions.Hide());
	}
}
